// extracted by mini-css-extract-plugin
module.exports = {"ctaCard":"cta_ctaCard__t3VVg","inner":"cta_inner__1XPja","text":"cta_text__1ZX_S","button":"cta_button__2C_l8"};